import React, { useState } from "react";
import { BtnState } from "../interfaces/App";
import Icon, { IconType } from "./Icon";
import OTPInput from "./OTPInput";
import Slider from "./Slider";
import CustomSelectBox from "./CustomSelectBox";
export interface IOption {
    name: string;
    value: string;
}
function StoryBoard() {
    const [value, setValues] = useState("");
    const initialGroup: IOption = {name: "wähle", value: "0"};
    const [group, setGroup] = useState(initialGroup);
    // const [grpIdx, setGroupIdx] = useState(0);
    const [groups, setGroups] = useState([
        {name: "eins", value: "1"},
        {name: "zwei", value: "2"},
        {name: "drei", value: "3"},
        {name: "vier", value: "4"},
        {name: "funf", value: "5"},
        {name: "sechs", value: "6"},
        {name: "sieben", value: "7"}
    ] as IOption[]);
    // const getGroupIdx = (ev: any) => {
    //     setGroup(ev.target.value);
    //     const regEx = new RegExp(ev.target.value, "i");
    //     const i = groups.findIndex((g: any) => g.search(regEx) > -1);
    //     if (i > -1) {
    //         setGroupIdx(i);
    //     }
    // };
    // console.log(grpIdx);
    return (
        <div>
            <h1>StoryBoard</h1>
            <Icon icon={IconType.progress} state={BtnState.active} className={"border"}/>
            <Icon icon={IconType.globe} state={BtnState.active} className={"border"}/>
            <Icon icon={IconType.login} state={BtnState.active} className={"border"}/>
            <Icon icon={IconType.check} state={BtnState.active} className={"border"}/>
            <Icon icon={IconType.register} state={BtnState.active} className={"border"}/>
            <Icon icon={IconType.search} state={BtnState.active} className={"border"}/>
            <Icon icon={IconType.infoCircle} state={BtnState.active} className={"border"}/>
            <Icon icon={IconType.pencil} state={BtnState.active} className={"border"}/>
            <Icon icon={IconType.key} state={BtnState.active} className={"border"}/>
            <Icon icon={IconType.lock} state={BtnState.active} className={"border"}/>
            <Icon icon={IconType.save} state={BtnState.active} className={"border"}/>
            <Icon icon={IconType.asterisk} state={BtnState.active} className={"border"}/>
            <Icon icon={IconType.user} state={BtnState.active} className={"border"}/>
            <Icon icon={IconType.logout} state={BtnState.active} className={"border"}/>
            <Icon icon={IconType.locationArrow} state={BtnState.active} className={"border"}/>
            <Icon icon={IconType.upload} state={BtnState.active} className={"border"}/>
            <Icon icon={IconType.trash} state={BtnState.active} className={"border"}/>
            <Icon icon={IconType.check} state={BtnState.active} className={"border"}/>
            <Icon icon={IconType.arrowRight} state={BtnState.active} className={"border"}/>
            <Icon icon={IconType.times} state={BtnState.active} className={"border"}/>
            <Icon icon={IconType.eye} state={BtnState.active} className={"border"}/>
            <Icon icon={IconType.eyeOff} state={BtnState.active} className={"border"}/>
            <Icon icon={IconType.cloud} state={BtnState.active} className={"border"}/>
            <Icon icon={IconType.back} state={BtnState.active} className={"border"}/>
            <hr/>
            <OTPInput length={10} value="abcd" setState={(val: string) => setValues(val)} />
            {value}
            <Slider className="mySlider" />
            {/* <hr/>
            <input 
                value={group}
                onChange={getGroupIdx}
            />
            <select
                defaultValue={groups[grpIdx]}
                value={groups[grpIdx]}
            >
                {groups.map((g: string, idx: number) => {return (<option key={"grp_" + idx} value={g}>{g}</option>)})}
            </select> */}
            <hr/>
            <CustomSelectBox
                label={"Group"}
                list={groups}
                rows={0}
                className="custom_select_box"
                value={group}
                onChange={(name: string, _: string) => {const g = groups.find((i: IOption) => i.name === name); setGroup({name, value: g ? g.value : "0"}); }}
                addItem={(val: string) => {const nl = [...groups]; nl.push({name: val, value: val}); setGroups(nl); }}
            />
            <CustomSelectBox
                label={"Group"}
                list={groups}
                rows={4}
                className="custom_select_box"
                value={group}
                onChange={(name: string, _: string) => {const g = groups.find((i: IOption) => i.name === name); setGroup({name, value: g ? g.value : "0"}); }}
            />
        </div>
    );
}
export default StoryBoard;
